import { getAPIUrl, Post } from "../../apiMethods";

export const authendpoint = {
  login: "restaurant/auth/login",
  customerRegister: "restaurant/customer/send-otp-customer",
  customerOtpVerify: "restaurant/customer/otp-verify",
  forgotPassword: "restaurant/auth/forgot-password",
  verifyForgotOtp: "restaurant/auth/verify-forgot-otp",
  resetPassword: "restaurant/auth/reset-password",
  register: "restaurant/auth/register",
  verifyRegisterOtp: "restaurant/auth/verify-otp",
  resendOtp: "restaurant/auth/resend-otp",
};

export const RestaurentLogin = (data, param = "") => {
  const url = getAPIUrl(authendpoint.login, param);
  return Post(url, data, false);
};

export const CustomerRegister = (data, param = "") => {
  const url = getAPIUrl(authendpoint.customerRegister, param);
  return Post(url, data);
};

export const CustomerOtpVerify = (data, param = "") => {
  const url = getAPIUrl(authendpoint.customerOtpVerify, param);
  return Post(url, data);
};

export const ForgotPassword = (data, param = "") => {
  const url = getAPIUrl(authendpoint.forgotPassword, param);
  return Post(url, data, false);
};

export const VerifyForgotOtp = (data, param = "") => {
  const url = getAPIUrl(authendpoint.verifyForgotOtp, param);
  return Post(url, data, false);
};

export const ResetPassword = (data, param = "") => {
  const url = getAPIUrl(authendpoint.resetPassword, param);
  return Post(url, data, false);
};

export const RestaurantRegister = (data, param = "") => {
  const url = getAPIUrl(authendpoint.register, param);
  return Post(url, data, false);
};

export const VerifyRegisterOtp = (data, param = "") => {
  const url = getAPIUrl(authendpoint.verifyRegisterOtp, param);
  return Post(url, data, false);
};

export const ResendOtp = (data, param = "") => {
  const url = getAPIUrl(authendpoint.resendOtp, param);
  return Post(url, data, false);
};
